import "./styles/intake.css";
import "./styles/outlet.css";
import Wrapper from "./Wrapper";

function App() {
  return (
    <div className="app">
      <Wrapper />
    </div>
  );
}

export default App;
